module.exports = __webpack_public_path__ + "img/logo.e030c3e2.png";